import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DxControlUtilsService } from '../../../_common/dx-control-utils.service';
import { BaseFieldComponent } from '../BaseField/basefield.component';
import { BaseComponent } from '../../../_common/dx-base-component';

@Component({
  selector: 'dx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
})
export class CheckBoxFieldComponent extends BaseComponent {
  @Input() checked: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() disabled: boolean = false;
  @Input() label!: string;
  @Input() name: any;
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private textControlSvc: DxControlUtilsService) {
    super(textControlSvc);
  }
  override ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['checked']) {
      // Force update the internal checked state
      this.checked = changes['checked'].currentValue;
    }
    if (changes['indeterminate']) {
      // Force update the internal indeterminate state
      this.indeterminate = changes['indeterminate'].currentValue;
    }
  }

  onCheckChange(event: any) {
    this.checked = event.checked;
    this.indeterminate = false; // Clear indeterminate when user clicks
    this.checkedChange.emit(event.checked);
    this.onChange.emit(event);
  }
}
